// Converts the flat `account_switcher.items` list into grouped orgs + a flat
// fallback list. Site rows belong to the most recent preceding org-header.
export function buildOrgSiteTree(items) {
  const orgs = [];
  const flatSites = [];
  let current = null;

  (items || []).forEach((item) => {
    if (item.type === 'org-header') {
      current = { orgId: item.organisation_id, orgName: item.text, sites: [] };
      orgs.push(current);
    } else if (item.type === 'site') {
      if (current) {
        current.sites.push({ id: item.value, name: item.text });
      } else {
        // Defensive: the backend appends org-less / org-not-visible accounts as
        // `flat` items, so a `site` row should always have a preceding header.
        // If one ever arrives without one, surface it rather than drop it.
        flatSites.push({ id: item.value, name: item.text });
      }
    } else if (item.type === 'flat') {
      // Sites with no organisation (or whose org the user can't see) arrive here.
      flatSites.push({ id: item.value, name: item.text });
    }
  });

  return { orgs, flatSites };
}
